import React, { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';

import { useHttpGetGatewayKpis } from '../../hooks';
import FleetHealthCards from './FleetHealthCards';
import GatewayAlarms from './GatewayAlarms';
import GatewayNeedsAttention from './GatewayNeedsAttention';
import GatewayByBrand from './GatewayByBrand';
import AsyncSection from './AsyncSection';
import { windowForHours } from './gatewayHealth';

// Dedicated fleet-health / diagnostics page: the health bucket cards plus the
// alarm breakdown, where each alarm drills into the affected gateways. Fixed to the
// last 24 hours (the current-state view); longer trends live on a gateway's history.
const FleetHealthPage = () => {
    // Window computed once on mount so it stays stable across re-renders.
    const [{ from, to }] = useState(() => windowForHours(24));

    const { overview, alarms, isReady, error } = useHttpGetGatewayKpis(from, to);

    return (
        <div className="gateways-overview">
            <Link className="gateways-page__back" to="/gateways">
                &#60; Back to gateways
            </Link>

            <div className="gw-fleet-header">
                <h1 className="gw-fleet-header__title">
                    Fleet health <span className="gw-fleet-header__subtitle">· last 24 hours</span>
                </h1>
            </div>

            <AsyncSection isReady={isReady} error={error} errorText="Could not load fleet health.">
                <div className="gw-fleet-body">
                    <FleetHealthCards overview={overview} />
                    <div className="gw-fleet-sections">
                        <div className="gateways-overview__alarms">
                            <h2 className="gateways-overview__alarms-title">Most frequent alarms</h2>
                            <p className="gateways-overview__alarms-hint">
                                Hourly reports containing each alarm in the last 24 hours. Select one to see the affected gateways.
                            </p>
                            <GatewayAlarms alarms={alarms} from={from} to={to} />
                        </div>
                        <GatewayNeedsAttention />
                    </div>
                    <GatewayByBrand from={from} to={to} />
                </div>
            </AsyncSection>
        </div>
    );
};

export default FleetHealthPage;
